<template>
  <FullscreenMessenger @locale-changed="handleLocaleChanged">
    <template v-slot:header>
      <div class="flex flex-col gap-2 items-center text-center mx-6">
        <p class="text-gray-300 font-medium text-sm">
          {{
            t("components.messenger.welcome.title", {
              tenant: tenant.name,
            })
          }}
        </p>
        <div class="w-[24px] h-[1px] m-2 bg-gray-300" />
        <h1 class="text-white text-4xl font-semibold">
          {{ props.space.name }}
        </h1>
        <p class="text-white">
          {{ t("components.messenger.welcome.description") }}
        </p>
      </div>
    </template>
    <template v-slot:content>
      <div class="flex flex-col items-center gap-4 pt-2 mt-8">
        <primary-button
          :label="t('components.messenger.welcome.cta')"
          @click="handleContinue"
          :loading="isLoading"
          :buttonStyle="'secondary'"
        />
        <span
          v-if="!isSpaceSelectionDisabled"
          class="cursor-pointer hover:text-gray-200 text-gray-300 font-medium text-sm"
          @click="handleChangeRoom"
          >{{ t("components.messenger.welcome.or_switch_room") }}</span
        >
      </div>
    </template>
  </FullscreenMessenger>
</template>

<script setup>
import { ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton.vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import FullscreenMessenger from "@/Tailwind/Layouts/FullscreenMessenger.vue";
import { useCookies } from "vue3-cookies";
import { useI18n } from "vue-i18n";

const props = defineProps({
  space: Object,
});

const { t } = useI18n();

const isLoading = ref(false);
const tenant = usePage().props.tenant;
const locale = usePage().props.locale;
const isSpaceSelectionDisabled =
  usePage().props.tenant.settings.disable_space_selection;

const { cookies } = useCookies();

const currentLocale = ref(cookies.get("messenger_locale") || locale);

function handleLocaleChanged(locale) {
  currentLocale.value = locale;
}

function handleChangeRoom() {
  router.visit(route("space.select", [tenant.slug]));
}

function handleContinue() {
  router.get(
    route("problem.detect", [tenant.slug, props.space.id]),
    {},
    {
      onStart: () => (isLoading.value = true),
      onFinish: () => (isLoading.value = false),
    }
  );
}
</script>
